module.exports = __webpack_public_path__ + "img/map_Z4.5.B.03.f9ae866d.svg";